<nz-upload
  (nzChange)="handleChange($event)"
  [nzBeforeUpload]="beforeUpload"
  [nzDisabled]="true"
  [nzShowUploadList]="false"
  class="avatar-uploader"
  nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
  nzListType="picture-card"
  nzName="avatar">
  @if (!currentUser?.signedUrl) {
    <nz-avatar
      [nzText]="
        (currentUser?.name?.firstName?.[0] || '') +
        (currentUser?.name?.lastName?.[0] || '')
      "
      [style]="'background-color:' + ('' | randomAvatarBackgroundColor)"
      class="aiomed-avatar"
      [nzSize]="78" />
  } @else {
    <nz-avatar
      [nzSrc]="currentUser?.signedUrl"
      class="aiomed-avatar"
      [nzSize]="78" />
  }
</nz-upload>
<div class="upload-text">
  {{ currentUser?.name?.firstName }} {{ currentUser?.name?.lastName }}
</div>
<ul class="upload-list">
  @if (!isMobile() && isUserAdmin()) {
    <li (click)="navigateToProfile.emit()">Monthly hours</li>
  }
</ul>
<ul class="privet-policy-support">
  <li>
    <a href="https://www.aiomed.com/privacy-policy" target="_blank"
      >Privacy Policy</a
    >
  </li>
  <li>Version - ({{ appVersion }})</li>
</ul>
